import { useEffect } from 'react';
import { useNavigate } from '@tanstack/react-router';
import { ReleaseList } from '@frontend/wam-views';
import { ContentLoader } from '@frontend/design-system';
import { Container } from '../../components/container/container';
import { Page } from '../../components/page-layout/page';
import { useS3 } from '../../hooks/useS3';
import { createFileRoute } from '../../utils/route-factory';

function DesktopReleases() {
  const navigate = useNavigate();

  const { loading, s3State, getInitialData, handleDownload } = useS3({
    prefix: 'weave-updates/',
  });

  useEffect(() => {
    getInitialData();
  }, [getInitialData]);

  const handleReleaseDetailsClick = (releaseId: string) => {
    navigate({
      to: '/global-settings/desktop-releases/$releaseId' as any,
      params: { releaseId } as any,
    });
  };
  return (
    <Page
      title='Release Management'
      css={{
        '& .page-header': {
          marginBottom: '8px',
          marginLeft: '8px',
        },
      }}
      breadcrumbs={[
        {
          label: 'Global Settings',
          to: '/global-settings',
        },
        {
          label: 'Desktop Releases',
        },
      ]}
    >
      <Container>
        {loading ? (
          <ContentLoader show={true} />
        ) : (
          <ReleaseList
            data={s3State.releaseTableData}
            onReleaseDetailsClick={handleReleaseDetailsClick}
            handleDownload={handleDownload}
          />
        )}
      </Container>
    </Page>
  );
}

export const Route = createFileRoute({
  path: '/global-settings/desktop-releases',
  component: DesktopReleases,
  type: 'auth',
});
